/**
 * Draggable sticker board — same layout + assets as amandazhu.co home fun-work.
 * Source files are PNG on the live site (no SVG equivalents for these stickers).
 */
export interface StickerSeed {
  id: number;
  src: string;
  /** 0–1, distance from top of board */
  top: number;
  /** 0–1, distance from left of board */
  left: number;
}

export const STICKER_BOARD_INITIAL: StickerSeed[] = [
  { id: 1, src: '/stickers/1-qwicmerch.png', top: 0.1, left: 0.06 },
  { id: 2, src: '/stickers/2-resumeworkshop.png', top: 0.05, left: 0.35 },
  { id: 11, src: '/stickers/id8-poster.png', top: 0.4, left: 0.06 },
  { id: 3, src: '/stickers/3-abighead.png', top: 0.2, left: 0.55 },
  { id: 4, src: '/stickers/4-coffeechat.png', top: 0.5, left: 0.4 },
  { id: 5, src: '/stickers/5-laylow.png', top: 0.48, left: 0.2 },
  { id: 6, src: '/stickers/6-creativemode.png', top: 0.36, left: 0.25 },
  { id: 7, src: '/stickers/7-qwicfolders.png', top: 0.54, left: 0.05 },
  { id: 8, src: '/stickers/8-qwicbunny.png', top: 0.32, left: 0.16 },
  { id: 9, src: '/stickers/qux-sticker.png', top: 0.2, left: 0.25 },
  { id: 10, src: '/stickers/qux-whatis.png', top: 0.35, left: 0.6 },
];
